import { render, staticRenderFns } from "./placeholder.vue?vue&type=template&id=8216817e&scoped=true"
import script from "./placeholder.vue?vue&type=script&lang=js"
export * from "./placeholder.vue?vue&type=script&lang=js"
import style0 from "./placeholder.vue?vue&type=style&index=0&id=8216817e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8216817e",
  null
  
)

export default component.exports